<!-- eslint-disable vue/no-parsing-error -->
<!-- eslint-disable vue/valid-v-for -->
<template>
  <div
    v-if="files.length"
    class="mt-3 mb-1 p-2 bg-light"
  >
    <base-text
      semibold
      class="mr-3"
      size="m"
    >
      Attachments:
    </base-text>
    <!-- before "file, index in files" -->
    <div
      v-for="file, index in files"
      :key="`attachment_${index}`"
    >
      <div :class="`${file.progress ? '' : 'ready'} d-flex justify-content-between`">
        <base-text
          size="s"
        >
          {{ file.name.length > 25 ? file.name.substring(0,25) + '...' : file.name }}
        </base-text>
        <base-icon
          v-if="!file.progress"
          style="min-width: 18px;"
          icon="remove-attachment"
          class="ml-2 align-self-center "
          @click="$emit('clear')"
        />
      </div>
      <base-progress-bar
        v-if="file.progress"
        class="mt-1"
        :current="file.progress"
      />
    </div>
    <div class="d-flex justify-content-start align-items-center" />
  </div>
</template>
<script>
export default {
  name: 'Attachments',
  props: {
    files: {
      type: Array,
      default: () => [],
    },
  },
};
</script>
<style lang="scss"
  scoped>
::v-deep .base-progress-bar {
  width: 100% !important;
  height: 9px;
  background-color: transparent;
  border: #aaa 1px solid;
  border-radius: 5px;
  position: relative;
  overflow: hidden;

  &__bar {
    position: absolute;
    height: 100%;
    background-color: #F2CEB1;
    margin: 0;
  }
}

td {
  font-family: $font-family-sans-serif;
  font-size: 13px;
}

.ready {
  border: 1px solid #aaa;
  border-radius: 5px;
  padding: 2px 13px;
}
.bg-light {
  background-color: $gray-light;
  border-radius: 3px;
}
</style>
